import { LinkProps } from 'evergreen-ui';
import React, { memo } from 'react';

export const FooterLink = memo<LinkProps>(({ children, ...rest }) => (
    <a rel="noopener" className="ev-overwrite portal-footer-link"
        {...rest}
    >
        {children}
    </a>
));
